import { useNavigate, useParams } from "react-router-dom";
import Query from "../common/Query";
import AddMembers from "./components/AddMembers";
import MemberListItem from "./components/MemberListItem";
import TableList from "./components/TableList";
import MEMBERS_QUERY from "./queries/MEMBERS_QUERY";
import { Alert, Button, Modal } from "react-bootstrap";
import { useState } from "react";
import {
  FetchResult,
  MutationFunctionOptions,
  useMutation,
  useQuery,
} from "@apollo/client";
import CONFIRM_ROSTER_MUTATION from "./queries/CONFIRM_ROSTER_MUTATION";
import AlertDismissible from "../common/AlertDismissible";
import ROSTER_STATUS_QUERY from "./queries/ROSTER_STATUS_QUERY";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ConfirmModal = ({
  show,
  handleClose,
  confirmRoster,
}: {
  show: boolean;
  handleClose: () => void;
  confirmRoster: (
    options?: MutationFunctionOptions<any, any, any, any>
  ) => Promise<FetchResult<any>>;
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirmRoster = async () => {
    setIsLoading(true);
    await confirmRoster();
    setIsLoading(false);
    handleClose();
  };
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirming Chapter Roster Up to Date</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        By selecting “Confirm” below you are verifying that a chapter volunteer
        representative has made all necessary changes to the chapter volunteer
        roster and the data to be submitted accurately depicts your active
        volunteers as of today.
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleClose}>
          Cancel
        </Button>
        {isLoading ? (
          <Button variant="success" disabled>
            Loading...
          </Button>
        ) : (
          <Button variant="success" onClick={handleConfirmRoster}>
            Confirm
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

const MemberListItems = ({
  volunteers,
  roles,
}: {
  volunteers: any;
  roles: any;
}) => {
  const list =
    (volunteers?.length &&
      volunteers.map((member: any, i: number) => (
        <MemberListItem member={member} key={member.LookupId} roles={roles} />
      ))) ||
    null;
  console.log("list", list, volunteers);
  return (
    <>
      <tbody>{list}</tbody>
    </>
  );
};

const ChapterDetails = () => {
  console.log("rendering chapterDetails");
  const { chapterId, chapterName } = useParams();
  const navigate = useNavigate();
  const { data: status } = useQuery(ROSTER_STATUS_QUERY, {
    variables: { chapterId },
  });
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [confirmRoster, { data: confirmed }] = useMutation(
    CONFIRM_ROSTER_MUTATION,
    {
      variables: {
        chapterId,
      },
    }
  );
  

  const showPrompt =
    status?.rosterStatus.showPrompt &&
    (confirmed ? confirmed?.confirmRoster.showPrompt : true);
  const promptMessage = status?.rosterStatus.message;
  const confirmedMessage = confirmed?.confirmRoster.message;
  
  

  console.log("confirmedMessage", confirmedMessage, confirmed);

  return (
    <>
    <Button
      className="ms-2"
      variant="light"
      size="sm"
      onClick={() => navigate(`/events/`)}
    >
      <FontAwesomeIcon icon="left-long" /> Back to Events
    </Button>
      <Query variables={{ chapterId }} query={MEMBERS_QUERY}>
        {({
          data: { volunteers, volunteerRoles: roles },
        }: {
          data: { volunteers: any[]; volunteerRoles: any[] };
        }) => {
          return (
            <>
              {confirmed && (
                <AlertDismissible className="my-5" variant="success">
                  You have succesfully confirmed your volunteer roster!
                </AlertDismissible>
              )}
              <div className="mt-4 mb-2">
              <h3>
                {decodeURIComponent(chapterName || "Chapter")} - Volunteers
              </h3>
              <Alert className="my-4"><FontAwesomeIcon icon="flag" style={{marginRight: '1em'}} /> You can update your volunteer roster at any time and as many times as needed to keep it accurate.</Alert>
              </div>
              {!confirmed && showPrompt && (
                <Button
                  className="float-end"
                  variant="success"
                  onClick={handleShow}
                >
                  Confirm Roster Up to Date
                </Button>
              )}
              {(confirmedMessage || promptMessage) && !showPrompt && (
                <p className="float-end">{confirmedMessage || promptMessage}</p>
              )}

              <TableList>
                <MemberListItems volunteers={volunteers} roles={roles} />
              </TableList>
              <AddMembers
                roles={roles}
                chapterName={decodeURIComponent(chapterName || "Chapter")}
              />

              {!confirmed && showPrompt && (
                <Button
                  className="float-end my-5"
                  variant="success"
                  onClick={handleShow}
                >
                  Confirm Roster Up to Date
                </Button>
              )}
              {(confirmedMessage || promptMessage) && !showPrompt && (
                <p className="float-end my-5">
                  {confirmed?.confirmRoster.message || promptMessage}
                </p>
              )}
            </>
          );
        }}
      </Query>
      <ConfirmModal
        show={show}
        handleClose={handleClose}
        confirmRoster={confirmRoster}
      />
    </>
  );
};

export default ChapterDetails;
